const $ = jQuery.noConflict();

class ScrollTo {
    constructor(scrollBtn, header='main-header') {
        this.scrollBtn = scrollBtn;
        this.header = header;
    }
    init() {
        $(this.scrollBtn).on('click', e => {
            const section = $(e.currentTarget).closest('section');
            const index = $('section').index(section) + 1;
            const nextSection = $('section').eq(index);
            const nextSectionOffset = nextSection.offset().top;
            const headerHeight = $(this.header).outerHeight();

            if(nextSection.length > 0){
                $('html, body').animate({
                    scrollTop: nextSectionOffset - headerHeight
                }, 400);
            }

        });
    }
}

const scrollToNextSection = new ScrollTo('.scroll-down');
export default scrollToNextSection;